import { DailyChallengeAnimation } from '@kp/shared/components/daily-challenge/daily-challenge-animation.enum';

export interface DailyChallengeState {
  seenFirstBuild?: boolean;
  currentAnimation?: DailyChallengeAnimation;
  seenCelebration?: boolean;
}

export const BASE_DAILY_CHALLENGE_STATE = {
  seenFirstBuild: false,
  currentAnimation: DailyChallengeAnimation.build,
  seenCelebration: false,
};
